<template>
  <v-layout id="login" align-center justify-center>
    <v-flex xs12 md6>
      <v-layout row align-center justify-center>
        <v-flex xs12 md10 lg8>
          <img class="logo" src="/static/images/logo.png">
          <v-toolbar-title class="toolbar-title">Recuperar senha</v-toolbar-title>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-text>
              <v-text-field prepend-icon="fal fa-user" v-model="form.email"
                label="E-mail" type="text" :rules="emailRules" required></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click.stop="recovery()" round large depressed color="success"
                :loading="loadingRequest" :disabled="!valid">
                Recuperar senha
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 md6 fill-height class="login-image" hidden-sm-and-down></v-flex>
  </v-layout>
</template>

<script>
import router from '@/router'
import EventBus from '@/event-bus'
import { Auth } from 'aws-amplify'

export default {
  name: 'LoginForgot',
  data: () => ({
    valid: true,
    loadingRequest: false,
    form: {
      email: ''
    },
    emailRules: [
      v => !!v || 'Campo obrigatório',
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Informe um e-mail válido'
    ]
  }),

  methods: {
    recovery () {
      if (this.$refs.form.validate()) {
        this.loadingRequest = true

        Auth.forgotPassword(this.form.email)
          .then(() => {
            EventBus.$emit('showSnackbar', {
              message: 'Enviamos um código para redefinir a senha para o seu email. Insira o código a nova senha no campo abaixo.',
              color: 'success'
            })

            router.push({ name: 'LoginNewPassword', params: { email: this.form.email } })

            this.loadingRequest = false
          })
          .catch(errors => {
            EventBus.$emit('showSnackbar', {
              message: 'Ocorreu um erro ao recuperar a senha',
              color: 'error'
            })

            this.loadingRequest = false
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LoginForgot.vue